import { FormattedMessage } from 'react-intl';
import useAttendance from 'src/hooks/attendance/useAttendance';

interface AttendanceSummaryProps {
  classId: number;
  studentUserId: number;
}

export default function AttendanceSummary({ classId, studentUserId }: AttendanceSummaryProps) {
  const { data } = useAttendance(classId, studentUserId);

  if (!data) return null;

  const approved = data.filter(entry => entry.approvedBy != null).length;

  return (
    <div className="mt-2 text-customGray" data-testid="attendance-summary">
      <FormattedMessage id="attendance-summary" values={{ approved, scheduled: data.length }} />
    </div>
  );
}
